module.exports = __webpack_public_path__ + "assets/images/amira_pd_alert_modal_open.ab4774f711e675cfa8060fee11257962.svg";